export default __webpack_public_path__ + "static/media/batLogo.6544b102.png";